import styled from 'styled-components';

export const PlaceHolder = styled.div``;

export const Content = styled.div`
  /* height: 500px; */
  background-color: #222;
  position: relative;
  margin-left: 3ch;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.2;
  border-radius: 0 3px 3px 0;
  box-sizing: border-box;
  textarea {
    box-sizing: border-box;
    display: block;
    border: 1px solid #fff;
    border-width: 1px 1px 1px 0;
    font-family: monospace;
    font-size: 12px;
    line-height: 1.2;
    resize: none;
    overflow: hidden;
    /* height: 512px; */
    /* width: 100%; */
    /* max-width: 646px; */
    padding: 0px 2px;
    word-break: break-all;
    white-space: nowrap;
    background: #fff;
    margin: 0;
    /* position: absolute; */
    color: rgb(73, 80, 87);
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    border-radius: 0 3px 3px 0;
    &:focus {
      outline: none;
    }
  }
`;
